import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { api } from "services/api";
import studyTimerReducer from "state/reducers/studyTimerSlice";
// import { themeReducer } from "state/reducers/theme";
import themeReducer from "state/reducers/themeSlice";
import layoutReducer from "state/reducers/layoutSlice";
import storage from "redux-persist/lib/storage";
import { authReducer } from "state/reducers/AuthSlice";
import { persistReducer, persistStore } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import {mcatChatApi} from "../../services/mcatChat/mcatChatApi";

const persistConfig = {
  key: "root",
  version: 1,
  storage: storageSession,
};

const authPersistConfig = {
  key: "auth",
  version: 1,
  storage,
  // Exclude mcatChatDoNotShowTransitionWarning from persistence since it's managed via cookies
  blacklist: ["mcatChatDoNotShowTransitionWarning"],
};

const authPersistedReducer = persistReducer(authPersistConfig, authReducer);

const persistedReducer = persistReducer(persistConfig, studyTimerReducer);

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    [mcatChatApi.reducerPath]: mcatChatApi.reducer,
    theme: themeReducer,
    layout: layoutReducer,
    studyTimer: persistedReducer,
    auth: authPersistedReducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat([
    api.middleware,
    mcatChatApi.middleware
  ]),
});

export let persistor = persistStore(store);

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
